import React from 'react'
import StepBubble from './StepBubble'
import Button from '../Templates/RedesignButton'
import StepsGroup from './StepsGroup'
import PriceDetails from './PriceDetails'
import { ReactComponent as Arrow } from '../../../assets/icons/arrow.svg'
import { withRoutingTracker } from '../../HOC/withRoutingTracker'
import MobileStepIndicator from './MobileStepIndicator'

/**
 * Stepper that allows navigation through cushion designer, the same component is used
 * both on desktop and mobile
 *
 * @module Stepper
 *
 * @returns {ReactElement} Stepper Component
 */
const Stepper = ({
  steps,
  stepperIndex,
  canProceedToNextStep,
  handleNextStepClick,
  handlePreviousClick,
  price,
  addToCart,
  addingToCart,
  history,
}) => {
  const isSingleFabric = history?.location?.search?.includes('viewing')

  const separateSteps = () => {
    const prevSteps = steps.slice(0, stepperIndex)
    const currentStep = steps[stepperIndex]
    const nextSteps = steps.slice(stepperIndex + 1)

    return { prevSteps, currentStep, nextSteps }
  }

  const { prevSteps, currentStep, nextSteps } = separateSteps()
  const isFirstStep = stepperIndex === 0

  const isLastStep = !isFirstStep && stepperIndex === steps.length - 1
  const showTotalPrice = currentStep?.title?.toLowerCase() !== 'set'

  if (isSingleFabric) {
    return null
  }

  return (
    <>
      <div className="stepper-wrapper-mobile">
        <div className="header-section">
          <StepBubble
            className="step-bubble first-step"
            key={`${currentStep.title}-${stepperIndex}`}
            type="current"
            step={stepperIndex + 1}
            disabled
          />
          <div className="step-title">{currentStep.title}</div>
        </div>
      </div>
      <div className="stepper-wrapper">
        <div className="stepper-inner-wrapper">
          <div className="header-section">
            <div className="step-title">{currentStep.title}</div>
          </div>
          <div className="action-section">
            {!isFirstStep ? (
              <>
                <Button
                  className="button first-step step-back-button"
                  variant="primaryIcon"
                  type="button"
                  onClick={handlePreviousClick(stepperIndex - 1)}
                >
                  <Arrow viewBox="0 0 8 12" width="8" height="12" className="stepper-back-arrow" />
                </Button>
                <PriceDetails
                  showTotalPrice={showTotalPrice}
                  price={price}
                  isExtendedStepper={true}
                  isLastStep={isLastStep}
                  addToCart={addToCart}
                  canProceedToNextStep={canProceedToNextStep}
                  addingToCart={addingToCart}
                />
              </>
            ) : <div/>}
            {isLastStep ? (
              <Button
                variant="primary"
                className="add-to-cart-button mobile-add-to-cart"
                onClick={addToCart}
                disabled={!canProceedToNextStep || addingToCart}
              >
                Add to Cart
              </Button>
            ) : (
              <Button
                className={`next-step-button primary-label ${isFirstStep && !steps.length - 1 && !nextSteps?.length ? 'mobile-next-button' : ''}`}
                onClick={handleNextStepClick}
                disabled={!canProceedToNextStep}
              >
                Next
                <Arrow viewBox="0 0 8 12" width="8" height="12" className="stepper-next-arrow" />
              </Button>
            )}
          </div>
          {stepperIndex !== 0 && (
            <div className="step-bubbles-wrapper">
              <StepsGroup
                steps={prevSteps}
                type="previous"
                handlePreviousClick={handlePreviousClick}
              />
              <StepBubble
                className="step-bubble first-step"
                key={`${currentStep.title}-${stepperIndex}`}
                type="current"
                step={stepperIndex + 1}
                disabled
              />
              <StepsGroup steps={nextSteps} type="next" />
            </div>
          )}
        </div>
        {!isFirstStep && (
          <MobileStepIndicator
            currentStep={stepperIndex}
            totalSteps={steps?.length}
          />
        )}
      </div>
    </>
  )
}

export default withRoutingTracker(Stepper)
